import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div className="p-2">Page not found</div>
        );
    }
}
export default NotFound; 